import {
  DocumentSnapshot,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  QueryConstraint,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageModuleData } from "../types";

export type ModulesListResult = {
  modules: PageModuleData[];
  lastVisible: DocumentSnapshot | null;
  hasMore: boolean;
};

export const getModulesListByBrandPage = async (
  brandId: string,
  pageId: string,
  pageSize: number = 20,
  lastVisible?: DocumentSnapshot | null,
): Promise<ModulesListResult> => {
  try {
    const collectionRef = collection(
      db,
      `brands/${brandId}/pages/${pageId}/modules`,
    );

    const queryConstraints: QueryConstraint[] = [
      orderBy("order", "asc"),
      limit(pageSize + 1),
    ];

    if (lastVisible) {
      queryConstraints.push(startAfter(lastVisible));
    }

    const q = query(collectionRef, ...queryConstraints);
    const pagesSnapshot = await getDocs(q);

    const modules = pagesSnapshot.docs
      .slice(0, pageSize)
      .map((doc) => ({ ...doc.data(), id: doc.id }) as PageModuleData);

    const hasMore = pagesSnapshot.docs.length > pageSize;

    const newLastVisible =
      modules.length > 0 ? pagesSnapshot.docs[modules.length - 1] : null;

    return {
      modules,
      lastVisible: newLastVisible,
      hasMore,
    };
  } catch (error) {
    console.error("Failed to fetch modules list:", error);
    throw error;
  }
};
